<div class="row" style="margin-top: 10px;">
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.RESOURCE_ID" (ngModelChange)="selectItem($event)">
        <option>SELECT</option>
        @for (item of listResourceSow; track item) {
          <option value="{{item.RESOURCE_ID}}">{{item.USERNAME}}</option>
        }
      </select>
      <label for="">Resource name *</label>
    </div>
  </div>
  <div class="col-lg-4"></div>
  <div class="col-lg-4"></div>
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.EPIC_ID" (ngModelChange)="selectEpic($event)">
        <option>SELECT</option>
        @for (item of listEpic; track item) {
          <option value="{{item.WORKITEMID}}">{{item.TITLE}}</option>
        }
      </select>
      <label for="">Epic *</label>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.FEATURE_ID" (ngModelChange)="selectFeature($event)">
        <option>SELECT</option>
        @for (item of listFeature; track item) {
          <option value="{{item.WORKITEMID}}">{{item.TITLE}}</option>
        }
      </select>
      <label for="">Feature (Optional)</label>
    </div>
  </div>
  <div class="col-lg-2">
  </div>
  <div class="col-lg-10">
    <div class="form-group has-float-label">
      <input [(ngModel)]="resource.WORKITEMNAME" class="form-control" id="" type="text"
        placeholder="Task Title"/>
        <label for="">Task Title (Optional)</label>
      </div>
    </div>
    <div class="col-lg-2"> </div>
    <div class="col-lg-3">
      <div class="form-group has-float-label">
        <select class="form-control" [(ngModel)]="resource.TYPE" (ngModelChange)="resource.updated = true">
          <option>SELECT</option>
          @for (item of listTaskType; track item) {
            <option value="{{item.TIMELOG_TYPE}}">{{item.TIMELOG_TYPE}}</option>
          }
        </select>
        <label for="">Task Type *</label>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group has-float-label">
        <input [(ngModel)]="resource.DATE" type="date" class="form-control"
          placeholder="dd/mm/yyyy" id="date"/>
          <label for="">Date *</label>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group has-float-label">
          <input [(ngModel)]="resource.EFFECTIVE_TIME" class="form-control" id="" type="text"
            placeholder="Work Time"/>
            <label for="">Work Time (hours) *</label>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group has-float-label">
            <input [(ngModel)]="resource.MONTHLY_COST" class="form-control" id="" type="text"
              placeholder="Monthly Cost"/>
              <label for="">Monthly Cost *</label>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="col-lg-4" style="float: right;">
              <button type="submit" class="btn btn-sm btn-block btn-danger claroredbg" (click)="saveForecast()"><i class="fa fa-save"></i> Save</button>
            </div>
          </div>
        </div>
